import { render, staticRenderFns } from "./MudarGrupoExitente.vue?vue&type=template&id=b5f53222"
import script from "./MudarGrupoExitente.vue?vue&type=script&lang=js"
export * from "./MudarGrupoExitente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports